import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const auth = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

export const TIPOS_CONTENEDOR = ["20", "40", "40HQ", "45HQ"];
export const MODALIDADES = ["Puerto", "Tren a Pantaco", "Camión"];
export const QUIEN_PAGA = ["Cliente", "Broker"];

// Etapas del viaje que avanzan solas con ShipsGo (antes de las etapas de México)
export const ETAPAS_VIAJE = ["Espacio confirmado", "Cargado en origen", "En puerto de origen", "Zarpó", "Transbordo", "Arribó"];

// Fecha "vacía" (antes se guardaba 2000-01-01 cuando no había fecha)
export const sinFecha = (f) => !f || f === "2000-01-01" || f === "NA";
export const muestraFecha = (f) => (sinFecha(f) ? "" : f);

// Dígito verificador ISO 6346 (mismo cálculo que el back): A=10 y se saltan los múltiplos de 11
const VALOR_LETRA = (() => {
  const m = {};
  let v = 10;
  for (const l of "ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    if (v % 11 === 0) v++;
    m[l] = v++;
  }
  return m;
})();

export function revisaNumeroContenedor(valor) {
  const numero = String(valor || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (!numero) return "";
  if (!/^[A-Z]{4}\d{7}$/.test(numero)) return "Debe ser 4 letras + 7 números (ej. MSCU1234567)";
  let suma = 0;
  for (let i = 0; i < 10; i++) suma += (i < 4 ? VALOR_LETRA[numero[i]] : Number(numero[i])) * Math.pow(2, i);
  const esperado = (suma % 11) % 10;
  return esperado === Number(numero[10]) ? "" : `El dígito verificador debería ser ${esperado} (norma ISO 6346)`;
}

// Cliente cuyo prefijo coincide con el inicio de la referencia (gana el prefijo más largo)
export function clientePorPrefijo(clientes, referencia) {
  const ref = String(referencia || "").trim().toUpperCase();
  if (!ref) return null;
  let mejor = null;
  let largo = 0;
  for (const c of clientes || []) {
    for (const p of c.prefijos || []) {
      const pre = String(p).toUpperCase();
      if (pre && ref.startsWith(pre) && pre.length > largo) {
        mejor = c;
        largo = pre.length;
      }
    }
  }
  return mejor;
}

export function usePuertos() {
  const [puertos, setPuertos] = useState([]);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_PUERTOS, { headers: auth() })
      .then(({ data }) => setPuertos(Array.isArray(data) ? data.filter((p) => p.is_active !== "No") : []))
      .catch(() => setPuertos([]));
  }, []);
  return puertos;
}

// Avisos del back antes de guardar (dígito verificador, viaje abierto duplicado).
// Envía otra vez con confirmado:true si el usuario acepta; si no, lanza { cancelado: true }.
export async function guardaConAvisos(enviar) {
  try {
    return await enviar(false);
  } catch (error) {
    const d = error?.response?.data;
    if (error?.response?.status === 409 && d?.requiereConfirmacion) {
      const r = await Swal.fire({
        icon: "warning",
        title: "Revisa antes de guardar",
        html: (d.avisos || []).map((a) => `<p style="text-align:left">• ${a.mensaje}</p>`).join(""),
        showCancelButton: true,
        confirmButtonText: "Guardar de todos modos",
        cancelButtonText: "Corregir",
        reverseButtons: true,
      });
      if (r.value) return enviar(true);
      const e = new Error("cancelado");
      e.cancelado = true;
      throw e;
    }
    throw error;
  }
}

// Revisión en vivo al salir del campo (no bloquea; solo muestra el aviso)
export async function avisosEnVivo({ referencia, numeroReferencia, id }) {
  try {
    const { data } = await axios.post(process.env.REACT_APP_URL_CONTENEDORES_VALIDAR, { referencia, numeroReferencia, id }, { headers: auth() });
    return (data.avisos || []).filter((a) => a.tipo === "duplicado");
  } catch (_) {
    return [];
  }
}
